
    import I18n from 'i18nObj';
    
      import 'translations/assignments.available_date_description';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('assignments.available_date_description');
  